import { Component, OnInit, TemplateRef } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../app/auth/auth.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableData } from '../../../app/utilities/nz-table.adapter';
import { MerchantTransactionSearch } from '../../../app/models/merchant-transactions';
import { countries } from '../../utilities/countries';
import { SettlementStatus, emptyFields, SettlementType, TransactionAccountTypes,
UsersType,
commentsType, SettlementFrequency, gstColumnName} from '../../utilities/common-file';
import { SettlementService } from './../settlements.service';
import { MerchantSearch } from 'src/app/models/merchant';
import { CommonService } from 'src/app/utilities/common-service';

@Component({
  selector: 'app-do-settlement',
  templateUrl: './do-settlement.component.html',
})
export class DoSettlementComponent implements OnInit {
  merchantUserLedger: UntypedFormGroup;
  settlementName: string;
  countries = countries;
  settlementStatus = SettlementStatus;
  merchantCurrency: any;
  emptyField = emptyFields;
  transactionAccountTypes = TransactionAccountTypes;
  settlementType  = SettlementType;
  calculatedValues = '';
  locationsList = [];
  locationId = '';
  // Loading spinner in table
  loading = true;
  loadingText = 'Loading';
  data = [];
  filterVisble: boolean;
  merchantName: string;
  merchantId: string;
  locationIdList: Location[] = [];
  tplModal: NzModalRef;
  claimForm: UntypedFormGroup;
  totalFlexmGst = 0;
  totalFlexmFee = 0;
  tplModalButtonLoading = false;
  userName: string;
  loginUserType: string;
  userTypes = UsersType;
  loadingForSettlementDetails = false;
  disableButton = false;
  selectedMerchant: any;
  totalAmount = 0;
  currencySymbol = '';
  totalTransactionFee = 0;
  totalNetAmount = 0;
  totalBankFee = 0;
  settlementByText = 'FlexM';
  selectedTransaction: any;
  selectedLocation: string;
  tplModalMerchant: NzModalRef;
  isOrderDelivered = true;
  totalCommission=0;
  totalGST =0;
  grandTotal=0;
  gst:any = localStorage.getItem('gst');
  hst:any = localStorage.getItem('hst');
  gstColumnName = gstColumnName;
  columnName :any;
  public calculatedValuesForMerchant: any;

  // tslint:disable-next-line: max-line-length
  private tableData: NzTableData<
    MerchantTransactionSearch, any> = new NzTableData<MerchantTransactionSearch, any>(
    new MerchantTransactionSearch(), 'transactionStatus');
    public tableDataForMerchants: NzTableData<
    MerchantSearch, any> = new NzTableData<MerchantSearch, any>(
    new MerchantSearch(), 'transactionStatus');
  // tslint:disable-next-line: max-line-length
  constructor(
    public fb: UntypedFormBuilder,
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
    public router: Router,
    public transctionService:SettlementService,
    public modalService: NzModalService,
    public notification: NzNotificationService,
    public settlementService: SettlementService,
    public commonService: CommonService
  ) {
    this.merchantUserLedger = this.fb.group({
      rangePicker: [[]],
      transactionType: ['all'],
    });
    this.claimForm = this.fb.group({
      claimAmount: [''],
      refId: ['', Validators.required],
      description: [''],
      completeSettlementStatus: [SettlementFrequency.off],
    });
  }

  ngOnInit() {
    this.hst = (this.hst === "true");
    this.gst = (this.gst === "true");
    if(this.gst && this.hst){
      this.columnName = this.gstColumnName.hst;
      }
      if(this.gst && !this.hst){
      this.columnName = this.gstColumnName.gst;
      }
    this.merchantId = this.authService.getMerchantId();
    this.locationId = this.authService.getLocationId();
    this.userName = this.authService.getDisplayName();
    this.loginUserType = this.authService.getRole();
    this.disableButton = true;
    this.getMerchant();
    this.getLocations();
    this.getMerchantSettlementCalculationForMerchant();
    if (this.selectedTransaction && !this.selectedTransaction.isSettlement) {
      this.getMerchantSettlementCalculation();
    }
    this.getTransactions();
  }
  getLocations() {
    this.locationsList = this.authService.getLocationDetails();
  }
  getSelectedLocation($event) {
    this.locationId = $event;
    this.calculatedValues = '';
    if (this.locationId) {
      this.getMerchantSettlementCalculation();
      this.disableButton = false;
    }
  }
  getMerchantSettlementCalculation() {
    this.loadingForSettlementDetails = true;
    const value = {
      // tslint:disable-next-line: radix
      merchantId: parseInt(this.merchantId),
      // tslint:disable-next-line: radix
      locationId: this.locationId ? parseInt(this.locationId) : '',

    };
    this.settlementService.settlementCalculation(value).subscribe((response: any) => {
      this.calculatedValues = response.data;
      this.loadingForSettlementDetails = false;
      if (this.loginUserType === UsersType.merchantUser) {
      this.getTransactions();
      }
    }, err => {
      this.calculatedValues = '';
      this.loadingForSettlementDetails = false;
    });
  }
  getMerchantSettlementCalculationForMerchant() {
    this.loadingForSettlementDetails = true;
    const value = {
      // tslint:disable-next-line: radix
      merchantId: parseInt(this.merchantId),
      withBankFeeGst:true

    };
    this.settlementService.getMerchantSettlementPending(value).subscribe((response: any) => {
      this.calculatedValuesForMerchant = response.data.merchantSettlementTransactions[0];
      this.selectedTransaction = this.calculatedValuesForMerchant;
      this.totalFlexmGst = response.data.totalFlexmGst.toFixed(2);
      this.totalFlexmFee = response.data.totalFlexmFee.toFixed(2);
      this.loadingForSettlementDetails = false;
      if (this.loginUserType === UsersType.merchantUser) {
        this.getTransactions();
      }
    }, err => {
      this.calculatedValuesForMerchant = '';
      this.loadingForSettlementDetails = false;
    });
  }
  getMerchant() {
    this.selectedMerchant = this.authService.getMerchantDetails();
    this.merchantCurrency = this.selectedMerchant.currency;
  }
  getTransactions(startFromPageOne: boolean = true): void {
    this.loading = true;
    this.tableData.data = [];
    if (startFromPageOne) {
      this.tableData.pageIndex = 1;
    }
    // tslint:disable-next-line: radix
    this.tableData.search.merchantId = parseInt(this.merchantId);
    // tslint:disable-next-line: radix
    this.tableData.search.locationId = parseInt(this.locationId);
    this.tableData.search.isSettled = false;
    this.tableData.search.createdDate.startDate = '';
    this.tableData.search.createdDate.endDate = '';
    this.tableData.search.accountType = '';
    this.tableData.search.isOrderDelivered = this.isOrderDelivered;
    this.settlementService.getTransactionsForSettlementWithLimit(this.tableData).subscribe(
      (response: any) => {
        this.loading = false;
        // this.totalTransactionFee = response.data.totalTransactionFee.toFixed(2);
        // this.totalNetAmount = response.data.totalNetAmount.toFixed(2);
        // this.totalAmount = response.data.totalAmount.toFixed(2);
        // this.grandTotal=response.data.grandTotal.toFixed(2),
        // this.totalCommission=response.data.totalCommission.toFixed(2);
        // this.totalGST=response.data.totalGst.toFixed(2);
        this.loading = false;
        this.tableData.total = response.data.total;
        this.tableData.data = response.data.transactions;
        this.getTransactionFooterData();
        //this.totalBankFee =  response.data.totalBankFee.toFixed(2);
      },
      (err) => {
        this.loading = false;
        this.tableData.data = [];
      }
    );
  }
  getTransactionFooterData(){
    this.tableData.search.merchantId = parseInt(this.merchantId);
    // tslint:disable-next-line: radix
    this.tableData.search.locationId =this.locationId ? parseInt(this.locationId) : '';
    this.tableData.search.appCode = this.selectedMerchant.appCode;
    this.transctionService.merchantTransactionSummary2(this.tableData).subscribe((response: any) => {

        this.totalTransactionFee=response.data.totalTransactionFee.toFixed(2);
           this.totalNetAmount=response.data.totalNetAmount.toFixed(2);
           this.totalBankFee=response.data.totalBankFee.toFixed(2);
           this.totalAmount=response.data.totalAmount.toFixed(2);
           this.grandTotal=response.data.grandTotal.toFixed(2),
           this.totalCommission=response.data.totalCommission.toFixed(2);
           this.totalGST=response.data.totalGst.toFixed(2);
        this.currencySymbol = this.commonService.getCurrencySymbol(this.tableData.search.appCode); 
     }, () => {
       this.tableData.data = [];
     });
  }
  onIndexChange(event) {
    this.tableData.pageIndex = event;
    this.getTransactions(false);
  }
  // Run Location Settlement Confirmation
  showConfirmationBeforeRunLocationSettlement() {
      this.tplModalButtonLoading = true;
      this.modalService.confirm({
        nzTitle: 'Are you sure you want to Run the Settlement?',
        nzOkText: 'Yes',
        nzOkType: 'danger',
        nzOnOk: () => this.runLocationSettlement(),
        nzCancelText: 'No',
        nzOnCancel: () => this.cancelSettlement()
      });
  }
  // Do Settlement
  runLocationSettlement() {
      this.tplModalButtonLoading = true;
      this.notification.info('Please wait', '', {
        nzKey: 'key',
      });
      const dataForSettlement = {
        // tslint:disable-next-line: radix
        locationId: parseInt(this.locationId),
        settlementBy: this.settlementByText,
      };
      this.settlementService.demandSettlement(dataForSettlement).subscribe((response: any) => {
        this.notification.success(response.message, '', {
          nzKey: 'key'
        });
        this.getMerchantSettlementCalculation();
    if (this.loginUserType !== UsersType.merchantUser) {
      this.getTransactions();
    }
      },
        () => {
          this.tplModalButtonLoading = false;
        }
      );
  }
  // Run Merchant Settlement Confirmation
  showConfirmationBeforeRunMerchantSettlement() {
    this.tplModalButtonLoading = true;
    this.modalService.confirm({
      nzTitle: 'Are you sure you want to Run the Settlement?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.runMerchantSettlement(),
      nzCancelText: 'No',
      nzOnCancel: () => this.cancelSettlement()
    });
}
cancelSettlement(){
  this.tplModalButtonLoading = false;
}
runMerchantSettlement() {
  const value = {
    merchantId: this.merchantId,
    completeSettlementStatus: this.claimForm.value.completeSettlementStatus
  }
  this.tplModalButtonLoading = true;
  this.settlementService.runMerchantSettlement(value).subscribe((response: any) => {
    // For Showing Comments in Merchant Transactions List
    this.tplModalButtonLoading = false;
    this.notification.success(response.message, '', {
      nzKey: 'key'
    });
    // this.destroyModalMerchant();
    this.getMerchantSettlementCalculationForMerchant();
    if (this.loginUserType == UsersType.merchantUser) {
      this.getTransactions();
    }
  },
    () => {
      this.tplModalButtonLoading = false;
    });
}

  addComments(transactionId, typeForComments) {
    const valueForComments = {
      comment: this.claimForm.value.description,
      referenceId: transactionId,
      type: typeForComments
    };
    this.commonService.createComments(valueForComments).subscribe((resComments: any) => {
    }, (errComments: any) => {
    });
  }
  getTransactionType(mode) {
    return this.commonService.getTransactionAccountType(mode);
  }
  // tslint:disable-next-line: indent
  getColorForTransactionType(mode) {
    return this.commonService.getColorForTransactionAccountType(mode);
  }
  getCurrency(currency) {
    const index = this.countries.findIndex((M) => M.currency_code === currency);
    if (index !== -1) {
      return this.countries[index].currency_symbol;
    }
  }
  error(message): void {
    this.modalService.error({
      nzTitle: 'Error',
      nzContent: message,
    });
  }
  success(message): void {
    this.modalService.success({
      nzTitle: 'Success',
      nzContent: message,
    });
  }
  // PaymentMethod
getPaymentMethod(mode) {
  return this.commonService.getPaymentMethod(mode);
}
// PaymentMethodColor
getColorForPaymentMethod(mode) {
  return this.commonService.getColorForPaymentMethod(mode);
}
}
